"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

__exportStar(require("./actions"), exports);

__exportStar(require("./reducers"), exports);

var reducers_1 = require("./reducers");

var redux_1 = require("redux");

var redux_thunk_1 = __importDefault(require("redux-thunk"));

var reducer = redux_1.combineReducers({
  authentication: reducers_1.authentication,
  units: reducers_1.units,
  unit: reducers_1.unit,
  state: reducers_1.state,
  time: reducers_1.time,
  alerts: reducers_1.alerts,
  graph: reducers_1.graph,
  filter: reducers_1.filter,
  usagePoints: reducers_1.usagePoints,
  usagePoint: reducers_1.usagePoint,
  user: reducers_1.user
});

function configureStore() {
  var middlewares = [redux_thunk_1.default];
  var middleWareEnhancer = redux_1.applyMiddleware.apply(void 0, __spread(middlewares));
  var store = redux_1.createStore(reducer, middleWareEnhancer);
  return store;
}

exports.default = configureStore;